import { Component } from '@theme/component';

/**
 * A dismissible floating video bubble. Wraps a `dialog-component` (which
 * handles opening/closing the video popup) and adds a separate close
 * action that removes the whole bubble from the page.
 */
class StickyVideo extends Component {
  hideBubble() {
    this.remove();
  }
}

if (!customElements.get('sticky-video-component')) {
  customElements.define('sticky-video-component', StickyVideo);
}
